import {connect} from '../../app/connect';
import IssueAttachmentGallery from './IssueAttachmentGallery';
import {closeGallery} from '../../app/actions';
import {getCurrentlyViewedAttachmentsWithThumbnails, getGallerySelectedIndex} from '../../app/selectors';

const mapStateToProps = state => ({
  selectedAttachmentIndex: getGallerySelectedIndex(state),
  attachments: getCurrentlyViewedAttachmentsWithThumbnails(state)
});

const mapDispatchToProps = {
  closeGallery
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueAttachmentGallery);
